module.exports = __webpack_public_path__ + "img/search.cc1fc74a.svg";